// Função para gerar a URL do avatar
const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }
  return color.substring(1); // Remove o '#'
};

export const getAvatarUrl = (nomeCompleto) => {
  if (!nomeCompleto) return '';

  const partes = nomeCompleto.trim().split(' ').filter(Boolean);
  const nome = partes.length === 1
    ? partes[0]
    : `${partes[0]}+${partes[partes.length - 1]}`;

  // Gera a cor de fundo com base no nome completo
  const bgColor = stringToColor(nomeCompleto);
  const color = 'ffffff'; // Cor do texto pode permanecer branca para contraste

  return `https://ui-avatars.com/api/?name=${encodeURIComponent(nome)}&background=${bgColor}&color=${color}`;
};